import Swiper, { Autoplay, Pagination } from 'swiper'

Swiper.use([Autoplay, Pagination])

export const HeroSlider = (target: HTMLDivElement, index: number) => {
  const el = {
    swiper: target.querySelector<HTMLButtonElement>('.hero-slider-block__swiper'),
    pagination: target.querySelector<HTMLDivElement>('.hero-slider-block__pagination'),
  }

  const method = {
    init: () => {
      if (!el.swiper || !el.pagination) return
      method.setIdentifiers(index)
      method.initializeSwiper()
    },

    initializeSwiper: () => {
      // @ts-ignore
      const swiper = new Swiper(el.swiper, {
        direction: 'horizontal',
        wrapperClass: 'hero-slider-block__wrapper',
        slideClass: 'hero-slider-block__slide',
        loop: true,
        grabCursor: false,
        autoplay: {
          delay: 10000,
        },
        autoHeight: false,
        slidesPerView: 1,
        pagination: {
          el: `.hero-slider-block__pagination--${index}`,
          bulletClass: 'hero-slider-block__bullet',
          bulletActiveClass: 'hero-slider-block__bullet--active',
          clickable: true,
          renderBullet: (index, className) => {
            const slide = el.swiper.querySelector<HTMLDivElement>(
              `.slide-block[data-index="${index}"]`
            )
            if (!slide) return ''

            const fallbackTitle =
              slide.querySelector<HTMLHeadingElement>('.slide-block__title')?.innerText ||
              ''
            const { title = '' } = slide.dataset

            return `
              <button type="button" class="${className}">
                <span class="hero-slider-block__bullet-text">${
                  title || fallbackTitle
                }</span>
              </button>
            `
          },
        },
        speed: 600,
      })
    },

    setIdentifiers: (index = 0) => {
      el.swiper.classList.add(`hero-slider-block__swiper--${index}`)
      el.pagination.classList.add(`hero-slider-block__pagination--${index}`)
    },
  }
  method.init()
}
